import useRouter from "./useRouter"

function useHistory() {
  const { history } = useRouter()
  return history
}

export default useHistory
